module.exports = __webpack_public_path__ + "media/assets/images/carded-blog-e430e5e6390b1447b90f3772acd252b2.svg";